import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultCardComponent } from '../result-card/result-card.component';
import { AnalysisResponse } from '@app/models/analysis.model';
import { NumberToWordPipe } from '@app/pipes/number-to-word.pipe';

@Component({
    selector: 'app-results',
    standalone: true,
    imports: [CommonModule, ResultCardComponent, NumberToWordPipe],
    templateUrl: './results.component.html',
    styleUrls: ['./results.component.scss'],
})
export class ResultsComponent {
    @Input() analysis!: AnalysisResponse;
}
